import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class CommonInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const skipLoader = request.headers.get('X-Skip-Loader');
    if (!skipLoader) {
      this.spinner.show();
    }

    const token = localStorage.getItem('accessToken');
    const isFormData = request.body instanceof FormData;

    // Build headers
    let headers = new HttpHeaders()
      .set("Authorization", `Bearer ${token || ''}`)
      .set("Access-Control-Allow-Origin", "*");

    // Only set content-type if NOT FormData
    if (!isFormData) {
      headers = headers.set(
        "content-type",
        request.headers.get("content-type") || "application/json"
      );
    }

    // Preserve 'accept' header if provided
    const accept = request.headers.get('accept');
    if (accept) {
      headers = headers.set('accept', accept);
    }

    const cloneRequest = request.clone({ headers });

    return next.handle(cloneRequest).pipe(
      catchError((err) => this.handleAuthError(err)),
      finalize(() =>
        setTimeout(() => this.spinner.hide(), 500)
      )
    );
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    console.log("HTTP Error:", err);

    const currentUrl = this.router.url;

    if (err.status === 401 && !currentUrl.includes('/auth/login')) {
      const translations = this.translateService.instant(['General.InvalidSession']);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.errorMessage || translations['General.InvalidSession']
      });
      // localStorage.removeItem('accessToken');
      localStorage.clear();
      this.router.navigate(['auth/login']);
    }

    return throwError(() => err);
  }
}
